import { LucideIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

interface TooltipIconProps {
  Icon: LucideIcon;
  tooltip: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

export function TooltipIcon({
  Icon,
  tooltip,
  size = 20,
  style = {},
  className = "",
}: TooltipIconProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={`inline-flex ${className}`}>
          <Icon 
            size={size} 
            style={style}
            className="transition-smooth hover:opacity-80"
          />
        </div>
      </TooltipTrigger>
      <TooltipContent 
        side="top"
        style={{
          backgroundColor: 'var(--popover)',
          color: 'var(--popover-foreground)',
          border: '1px solid var(--border)',
          boxShadow: 'var(--elevation-md)',
        }}
      >
        <p style={{ fontSize: 'var(--text-sm)' }}>{tooltip}</p>
      </TooltipContent>
    </Tooltip>
  );
}
